module.exports = __webpack_public_path__ + "assets/media/swallow_split_origin.cdc6a086.mp4";